import { render, staticRenderFns } from "./vehicleReservationError.vue?vue&type=template&id=1b12ea6f&scoped=true"
import script from "./vehicleReservationError.vue?vue&type=script&lang=js"
export * from "./vehicleReservationError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b12ea6f",
  null
  
)

export default component.exports